import logo from "../assets/logo.png"

function PreLoader() {
  return (
    <img src={logo} alt="TAMIL VOKKALIGA MATRIMONY" />
  )
}

export default PreLoader